export function getDirection(layout) {
  return layout === 'vertical' ? 'column' : 'row';
}
